import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { getUniformForm } from "../../services/uniformFormApi";
import { badge } from "../store/uniform/StoreUniformFormList";

const UniformFormView = () => {
  const { id } = useParams();
  const [f, setF] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    getUniformForm(id).then((r) => setF(r.data)).catch((e)=>setErr(e.message));
  }, [id]);

  if (!f) {
    return (
      <DashboardLayout title="Uniform Form Details">
        <div className="container-fluid">{err ? <div className="alert alert-danger">{err}</div> : <div className="text-center py-4"><span className="spinner-border spinner-border-sm me-2"/>Loading...</div>}</div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout title="Uniform Form Details">
      <div className="container-fluid">
        <div className="card p-4">
          <h3>
            {f.formNo}{" "}
            <span className={`badge bg-${badge(f.status)}`}>{f.status}</span>
          </h3>
          <div className="row">
            {Object.entries(f)
              .filter(([k]) =>
                [
                  "formNo",
                  "employeeCode",
                  "employeeName",
                  "designation",
                  "gender",
                  "mobile",
                  "uniformType",
                  "size",
                  "quantity",
                  "reason",
                  "remarks",
                  "adminRemarks",
                  "providedAt",
                  "providedRemarks",
                  "submittedAt",
                ].includes(k),
              )
              .map(([k, v]) => (
                <div className="col-md-4 mb-2" key={k}>
                  <small className="text-muted">{k}</small>
                  <div>{String(v ?? "-")}</div>
                </div>
              ))}
          </div>
          {(f.logs || []).length > 0 && (
            <div className="mt-3">
              <h5>Timeline / Logs</h5>
              {f.logs.map((l) => (
                <div key={l.id} className="border-start ps-3 mb-2">
                  <b>{l.action}</b>
                  <div className="text-muted">
                    {new Date(l.createdAt).toLocaleString()} | {l.actorType}
                    {l.remarks ? ` | ${l.remarks}` : ""}
                  </div>
                </div>
              ))}
            </div>
          )}
          <Link to="/uniform-forms" className="btn btn-outline-secondary mt-3">
            Back
          </Link>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default UniformFormView;
